import clsx from 'clsx';
import * as React from 'react';
import { DatatableProps, RowModel } from './types';

const Background = <TDataItem extends RowModel>({
  containerStyles,
  stickyHeader,
  children,
}: React.PropsWithChildren<
  Pick<DatatableProps<TDataItem>, 'containerStyles'> & {
    stickyHeader?: boolean;
  }
>) => {
  return (
    <div
      className={clsx('position-relative mb-0 p-2 bg-white rounded shadow-sm', {
        'overflow-auto': !stickyHeader,
      })}
      style={containerStyles}
    >
      {children}
    </div>
  );
};

export default Background;
